/**
 * 获取global文件夹下所有vue组件进行全局注册
 */
// src/**/*.tsx
// src/**/*.vue
import type { App } from 'vue'
const moduleFiles = import.meta.globEager('./global/*.vue')
const globalResult = Object.keys(moduleFiles).filter((_: any) => _)
export default {
  install(app: App) {
    globalResult.forEach((item) => {
      const fileName = item.split('/').slice(-1)[0]
      const componentName = fileName.replace('.vue', '')
      const component = moduleFiles[item]?.default

      app.component(componentName, component)
    })
  }
}
